import type { ConfigType } from '@plone/registry';

export default function applyConfig(config: ConfigType) {
  config.settings.pluggableStylesBlocksWhitelist = ['tabs_block'];

  return config;
}
